/**
 * @generated SignedSource<<f8720ef8992b6610e373c9676e8e2a4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "RemoveWidgetsResult",
    "kind": "LinkedField",
    "name": "finishedRemoveWidgetsSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "step",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "widgets",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sequence",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FinishedRemoveWidgetsSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FinishedRemoveWidgetsSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c9190bedac0ea38b901f3ce4a8758d6",
    "id": null,
    "metadata": {},
    "name": "FinishedRemoveWidgetsSubscription",
    "operationKind": "subscription",
    "text": "subscription FinishedRemoveWidgetsSubscription(\n  $filter: BaseSubscriptionInput!\n) {\n  finishedRemoveWidgetsSubscription(filter: $filter) {\n    id\n    step\n    widgets\n    sequence\n  }\n}\n"
  }
};
})();

node.hash = "661d3f9e394fb04245fdbf55a2301b56";

export default node;
